module.exports = "https://assets.bwbx.io/s3/reg2/images/download-icon-856558dfe219b6ef78a0.svg";